import { StatusBadge } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';

/**
 * Device name and online/offline status badge.
 */
export function BalenaDeviceCardTitle({ name, isOnline }: { name: string; isOnline: boolean }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 0.75,
      }}
    >
      <Typography variant="subtitle1" component="h3" noWrap sx={{ fontWeight: 500, minWidth: 0 }}>
        {name}
      </Typography>
      <StatusBadge status={isOnline} onText="Online" offText="Offline" />
    </Box>
  );
}
